import { useState } from 'react';
import { TrendingUp, Users, Calendar, Target, Brain, Zap } from 'lucide-react';
import AIDashboardView from './aidashboard.view';

const AIDashboard = () => {
  const [insights, setInsights] = useState([
    {
      title: 'Препорака за оптимизација',
      description: 'Вашите настани во април имаат 40% повисока стапка на регистрација. Препорачуваме да организирате повеќе настани во овој период.',
      icon: Target,
      color: 'bg-blue-500',
      priority: 'high'
    },
    {
      title: 'Анализа на локации',
      description: 'Настаните во Скопје имаат најголем број на регистрации. Средниот број на учесници е 350.',
      icon: TrendingUp,
      color: 'bg-green-500',
      priority: 'medium'
    },
    {
      title: 'Корисничко однесување',
      description: 'Најактивните корисници се жени на возраст 25-35 години, кои се регистрираат 2-3 недели пред настанот.',
      icon: Users,
      color: 'bg-purple-500',
      priority: 'medium'
    },
    {
      title: 'Препорака за сезоналност',
      description: 'Есенските настани (септември-октомври) имаат најголем интерес. Планирајте капацитет соодветно.',
      icon: Calendar,
      color: 'bg-orange-500',
      priority: 'high'
    }
  ]);

  const aiMetrics = [
    {
      label: 'Предвидена стапка на регистрација',
      value: '87%',
      change: '+12%',
      icon: Target
    },
    {
      label: 'Оптимални денови за настани',
      value: 'Сабота, Недела',
      change: '35% повисока стапка',
      icon: Calendar
    },
    {
      label: 'Препорачан капацитет',
      value: '450 учесници',
      change: 'Врз основа на историски податоци',
      icon: Users
    },
    {
      label: 'Најдобро време за промоција',
      value: '3 недели пред',
      change: 'Максимална ефективност',
      icon: Zap
    }
  ];

  const generateNewInsight = () => {
    const newInsights = [
      {
        title: 'Нова можност',
        description: 'Детектирано е зголемување на интересот за трејл трки. Размислете за организирање нови настани.',
        icon: Brain,
        color: 'bg-pink-500',
        priority: 'high'
      },
      {
        title: 'Предвидување на трендови',
        description: 'AI моделот предвидува зголемување на регистрациите за 23% во следниот квартал.',
        icon: TrendingUp,
        color: 'bg-indigo-500',
        priority: 'medium'
      }
    ];

    const randomInsight = newInsights[Math.floor(Math.random() * newInsights.length)];
    setInsights([randomInsight, ...insights]);
  };

  return (
    <AIDashboardView
      insights={insights}
      aiMetrics={aiMetrics}
      generateNewInsight={generateNewInsight}
    />
  );
};

export default AIDashboard;
